import Switch from '@eduzz/houston-ui/Forms/Switch';
import { Grid, FormHelperText, FormControlLabel, TextField, MenuItem, Tooltip, Select, FormControl, Radio } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { DatePicker } from '@material-ui/pickers';
import User from 'classes/User';
import CustomMaskedInput from 'components/MaskedInput';
import { constants } from 'helpers/constants';
import { functions } from 'helpers/functions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { run } from 'validations/ruleRunner';

import styles from './styles';
import Validations from './validations';
import BlockedFieldTooltipProps from '../../../General/blockedTooltipProps';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';
interface IProps extends DispatchProp<any>, StyledComponentProps {
  offer: IProduct;
  handleChange: any;
  loggedUser: any;
  modifieds: any;
  editing: any;
  onChangeRequiredFields: any;
  loading: boolean;
  isAlumy?: boolean;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  showStartChargingAt: boolean;
  chargeAtType: string;
}

export const recurrencyFrequencyType = {
  Mensal: { abbr: 'M', freq: 1 },
  Trimestral: { abbr: 'TM', freq: 3 },
  Semestral: { abbr: 'SM', freq: 1 },
  Anual: { abbr: 'Y', freq: 1 },
  Personalizado: { abbr: 'P', freq: 2 },
};
export const getFrequencyHelper = (product: any) => {
  const freq = product?.recurring_frequency ?? 0;
  const freqType = product?.recurring_frequency_type ?? 'M';
  const isPlural = freq > 1;
  const trimester = isPlural ? 'trimestres' : 'trimestre';
  const semester = isPlural ? 'semestres' : 'semestre';
  const year = isPlural ? 'anos' : 'ano';
  const frequencyText = {
    M: `Ex: Será cobrado a cada ${freq} ${freq > 1 ? 'meses' : 'mês'}`,
    TM: `Ex: Será cobrado a cada ${freq} ${trimester}`,
    SM: `Ex: Será cobrado a cada ${freq} ${semester}`,
    Y: `Ex: Será cobrado a cada ${freq} ${year}`,
    P: `Ex: Será cobrado a cada ${freq} `,
  };

  return frequencyText[freqType];
};

const CUSTOM_RECURRENCY = 'P';

class Subscription extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.offer, Validations),
      showStartChargingAt: props.offer.recurring_start_charging !== '' || props.offer.recurring_days_start_charging != null,
      chargeAtType: props.offer.recurring_days_start_charging !== null ? 'days' : 'date',
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  changeStates = () => {
    let { offer, onChangeRequiredFields } = this.props;
    let newState = { ...this.state };
    newState.validationErrors = run(offer, Validations);
    this.setState(newState);
    if (onChangeRequiredFields) {
      onChangeRequiredFields('subscriptionErrors', newState.validationErrors);
    }
  };

  handleChangeBillingFrequency = (frequencyType: string, value: any) => {
    this.props.handleChange(frequencyType, value);
  };

  startChargingClear = (value: boolean) => {
    const showStartChargingAt = value;

    if (!showStartChargingAt) {
      this.props.handleChange('recurring_start_charging', '', () => this.props.handleChange('recurring_days_start_charging', ''));
    }

    this.setState({ showStartChargingAt });
  };

  handleChangeAndClearStartDateDays = (e: any) => {
    this.props.handleChange('recurring_start_charging', '', () => this.props.handleChange('recurring_days_start_charging', ''));
    this.setState({ chargeAtType: e.target.value });
  };

  handleChangeRecurrencyType = (value: string) => {
    this.props.handleChange('recurring_frequency_type', value);
    if (value === CUSTOM_RECURRENCY) {
      this.props.handleChange('recurring_frequency', 2);
      this.props.handleChange('recurring_frequency_type_select', 'MONTH');
      return;
    }
    this.props.handleChange('recurring_frequency', 1);
  };

  handleChangeAfterRadio = () => {
    this.props.handleChange('undetermined_charges', false);
    this.props.handleChange('limit_charges', this.props.offer.limit_charges);
  };

  onChangeTrial = (value: boolean) => {
    const handleChange = this.props.handleChange;
    if (value) {
      handleChange('allows_boleto', false);
    }

    handleChange('trial', value);
  };

  checkIfIsCustomRecurring = () => {
    const { handleChange, offer } = this.props;
    const monthsTypes = ['M', 'TM', 'SM'];
    if (monthsTypes.includes(offer.recurring_frequency_type) && offer.recurring_frequency > 1) {
      handleChange('recurring_frequency_type', CUSTOM_RECURRENCY);
      handleChange('recurring_frequency_type_select', 'MONTH');
    }
    if (offer.recurring_frequency_type === 'Y' && offer.recurring_frequency > 1) {
      handleChange('recurring_frequency_type', CUSTOM_RECURRENCY);
      handleChange('recurring_frequency_type_select', 'YEAR');
    }
  };

  componentDidUpdate(prevProps: IProps) {
    const { offer, loading } = this.props;
    if (!loading && offer !== prevProps.offer && offer.charge_type === 'A') {
      this.changeStates();
    }
    if (!loading) {
      this.checkIfIsCustomRecurring();
    }
  }

  componentDidMount() {
    const { offer, loading } = this.props;
    if (!loading && offer.charge_type === 'A') {
      this.changeStates();
    }
  }

  render() {
    const userIsEadCharging = localStorage.getItem('eadCharging') && localStorage.getItem('eadCharging').toLowerCase() === 'true';
    const { showStartChargingAt, chargeAtType } = this.state;

    const { handleChange, offer, isAlumy, classes } = this.props;
    return (
      <>
        <Grid item xs={12}>
          <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
            <div>
              <CustomMaskedInput
                label='Preço'
                helperText={this.isValid('recurring_value') ? this.errorFor('recurring_value') : 'Ex: 1.000,00'}
                error={this.isValid('recurring_value')}
                fullWidth={true}
                disableUnderline={true}
                id='recurring_value'
                mask='money'
                value={functions.addMoneyMask(offer.recurring_value)}
                onChange={(value: any) => handleChange('recurring_value', value)}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={isAlumy}
              />
            </div>
          </BlockedFieldTooltipProps>
        </Grid>
        <Grid item xs={12}>
          <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
            <TextField
              label='Frequência de cobrança'
              id='recurring_frequency_type'
              select
              fullWidth
              value={offer.recurring_frequency_type}
              onChange={(e: any) => this.handleChangeRecurrencyType(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={isAlumy}
            >
              {Object.keys(recurrencyFrequencyType).map((type) => (
                <MenuItem key={type} value={recurrencyFrequencyType[type].abbr}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </BlockedFieldTooltipProps>
        </Grid>
        {offer.recurring_frequency_type === CUSTOM_RECURRENCY && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <p>Repetir a cada:</p>
                  <div style={{ width: '50px', margin: '0 10px', display: 'flex' }}>
                    <CustomMaskedInput
                      id='recurring_frequency'
                      error={this.isValid('recurring_frequency')}
                      mask='number'
                      disableUnderline={true}
                      value={offer.recurring_frequency}
                      onChange={(value: any) => handleChange('recurring_frequency', value)}
                      disabled={isAlumy}
                    />
                  </div>
                  <FormControl>
                    <Select
                      onChange={(e) => handleChange('recurring_frequency_type_select', e.target.value)}
                      value={offer.recurring_frequency_type_select}
                    >
                      <MenuItem value='MONTH'>{offer.recurring_frequency > 1 ? 'meses' : 'mês'}</MenuItem>
                      <MenuItem value='YEAR'>{offer.recurring_frequency > 1 ? 'anos' : 'ano'}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {this.isValid('recurring_frequency') && <FormHelperText error>{this.errorFor('recurring_frequency')}</FormHelperText>}
              </>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        <Grid item xs={12}>
          <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
            <div>
              <div className={isAlumy ? classes.disabledAlumyText : ''}>A cobrança termina em:</div>
              <div>
                <FormControlLabel
                  control={<Radio color='primary' />}
                  label='Nunca'
                  checked={offer.undetermined_charges}
                  onChange={(_, checked) => {
                    if (checked) {
                      handleChange('limit_charges', '2');
                    }
                    handleChange('undetermined_charges', checked);
                  }}
                  disabled={isAlumy}
                />
                <div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                    <FormControlLabel
                      style={{ marginRight: 0 }}
                      control={<Radio color='primary' />}
                      label='Após'
                      checked={!offer.undetermined_charges}
                      onChange={this.handleChangeAfterRadio}
                      disabled={isAlumy}
                    />
                    <div style={{ width: 57 }}>
                      <CustomMaskedInput
                        id='limit_charges'
                        mask='number'
                        error={this.isValid('limit_charges')}
                        onChange={(value: string) => {
                          if (value.length > 2) return;
                          handleChange('limit_charges', value);
                        }}
                        value={offer.limit_charges}
                        disabled={isAlumy || offer.undetermined_charges}
                      />
                    </div>
                    <span className={isAlumy ? classes.disabledAlumyText : ''}>{offer.limit_charges > 1 ? 'cobranças' : 'cobrança'}</span>
                  </div>
                  {this.isValid('limit_charges') && <FormHelperText error>{this.errorFor('limit_charges')}</FormHelperText>}
                </div>
              </div>
            </div>
          </BlockedFieldTooltipProps>
        </Grid>
        {!offer.undetermined_charges && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <Switch
                  value={offer.permanent_access}
                  onChange={(bool: boolean) => {
                    handleChange('permanent_access', bool);
                  }}
                  disabled={offer.undetermined_charges || isAlumy}
                >
                  Acesso permanente
                </Switch>
                <FormHelperText>Mantém o acesso mesmo após o término das cobranças.</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        <Grid item xs={12}>
          <Tooltip
            disableFocusListener={!(offer.trial || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            disableHoverListener={!(offer.trial || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            disableTouchListener={!(offer.trial || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            title={
              offer.trial
                ? 'A Adesão não pode ser habilitada junto com o Trial'
                : offer.yearly_installment
                ? 'A Adesão não pode ser habilitado junto com o Parcelamento da Recorrência'
                : offer.type === constants.PHYSICAL
                ? 'A Adesão não pode ser habilitado em produtos físicos'
                : ''
            }
            placement='bottom'
          >
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <Switch
                  value={offer.membership_fee}
                  onChange={(bool: boolean) => handleChange('membership_fee', bool)}
                  disabled={offer.trial || offer.yearly_installment || offer.type === constants.PHYSICAL || isAlumy}
                >
                  Taxa de contratação / adesão
                </Switch>
                <FormHelperText>O cliente deve pagar taxa de contratação</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Tooltip>
        </Grid>
        {offer.membership_fee && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <CustomMaskedInput
                  label='Valor da adesão'
                  id='membership_price'
                  mask='money'
                  error={this.isValid('membership_price')}
                  value={functions.addMoneyMask(offer.membership_price)}
                  onChange={(value: any) => handleChange('membership_price', value)}
                  fullWidth={true}
                  disableUnderline={true}
                  disabled={!offer.membership_fee || isAlumy}
                />
                <FormHelperText>{this.isValid('membership_price') ? this.errorFor('membership_price') : 'Ex: R$ 20,00'}</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {offer.membership_fee && userIsEadCharging && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <Switch
                  value={showStartChargingAt}
                  onChange={(bool: boolean) => this.startChargingClear(bool)}
                  disabled={!offer.membership_fee || isAlumy}
                >
                  Alterar data de inicio de cobrança
                </Switch>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {offer.membership_fee && showStartChargingAt && userIsEadCharging && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <TextField
                  label='Data / Número de Dias'
                  id='recurring_date_days_number'
                  select
                  fullWidth
                  helperText='Início de cobrança por data ou dias'
                  value={chargeAtType}
                  onChange={(e: any) => this.handleChangeAndClearStartDateDays(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={!showStartChargingAt || isAlumy}
                >
                  <MenuItem value='date'>Data</MenuItem>
                  <MenuItem value='days'>Número de Dias</MenuItem>
                </TextField>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {offer.membership_fee && userIsEadCharging && showStartChargingAt && chargeAtType !== 'days' && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <DatePicker
                  disableToolbar
                  variant='inline'
                  format='dd/MM/yyyy'
                  placeholder='DD/MM/YYYY'
                  value={offer.recurring_start_charging}
                  onChange={(date: any) => handleChange('recurring_start_charging', date)}
                  label='Começar a cobrar após'
                  helperText='A cobrança iniciará após da data escolhida'
                  id='recurring_start_charging'
                  InputProps={{
                    disableUnderline: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  minDate={new Date()}
                  disabled={(!showStartChargingAt && chargeAtType === 'date') || isAlumy}
                />
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {userIsEadCharging && showStartChargingAt && chargeAtType === 'days' && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <CustomMaskedInput
                  label='Começar a cobrar após'
                  fullWidth={true}
                  disableUnderline={true}
                  id='recurring_days_start_charging'
                  mask='number'
                  error={this.isValid('recurring_days_start_charging')}
                  helperText={
                    this.isValid('recurring_days_start_charging')
                      ? 'Informe um valor entre 1 e 365 dias.'
                      : 'A cobrança iniciará após o número de dias escolhidos em relação a data de faturamento'
                  }
                  value={offer.recurring_days_start_charging}
                  onChange={(value: any) => handleChange('recurring_days_start_charging', value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={isAlumy}
                />
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        <Grid item xs={12}>
          <Tooltip
            disableFocusListener={!(offer.membership_fee || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            disableHoverListener={!(offer.membership_fee || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            disableTouchListener={!(offer.membership_fee || offer.yearly_installment || offer.type === constants.PHYSICAL)}
            title={
              offer.membership_fee
                ? 'O Trial não pode ser habilitado junto com a Adesão'
                : offer.yearly_installment
                ? 'O Trial não pode ser habilitado junto com o Parcelamento da Recorrência'
                : offer.type === constants.PHYSICAL
                ? 'O Trial não pode ser habilitado em produtos físicos'
                : ''
            }
            placement='bottom'
          >
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <Switch
                  value={offer.trial}
                  onChange={(bool: boolean) => this.onChangeTrial(bool)}
                  disabled={offer.membership_fee || offer.type === constants.PHYSICAL || isAlumy}
                >
                  Período trial
                </Switch>
                <FormHelperText>Permitir que o cliente experimente o produto</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Tooltip>
        </Grid>
        {offer.trial && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <CustomMaskedInput
                  label='Dias para trial'
                  id='trial_days'
                  mask='number'
                  error={this.isValid('trial_days')}
                  value={offer.trial_days}
                  onChange={(value: any) => handleChange('trial_days', value)}
                  fullWidth={true}
                  disableUnderline={true}
                  disabled={!offer.trial || isAlumy}
                />
                <FormHelperText>{this.isValid('trial_days') ? this.errorFor('trial_days') : 'Ex: 15 dias'}</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {recurrencyFrequencyType.Mensal.abbr !== offer.recurring_frequency_type &&
          recurrencyFrequencyType.Personalizado.abbr !== offer.recurring_frequency_type && (
            <Grid item xs={12}>
              <Tooltip
                disableFocusListener={!(offer.trial || offer.membership_fee || offer.type === constants.PHYSICAL)}
                disableHoverListener={!(offer.trial || offer.membership_fee || offer.type === constants.PHYSICAL)}
                disableTouchListener={!(offer.trial || offer.membership_fee || offer.type === constants.PHYSICAL)}
                title={
                  offer.trial
                    ? 'O Parcelamento da Recorrência não pode ser habilitado junto com o Trial'
                    : offer.membership_fee
                    ? 'O Parcelamento da Recorrência não pode ser habilitado junto com a Adesão'
                    : offer.type === constants.PHYSICAL
                    ? 'O Parcelamento da Recorrência não pode ser habilitado em produtos físicos'
                    : ''
                }
                placement='bottom'
              >
                <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
                  <div>
                    <Switch
                      value={offer.yearly_installment}
                      onChange={(bool: boolean) => handleChange('yearly_installment', bool)}
                      disabled={offer.membership_fee || offer.type === constants.PHYSICAL || isAlumy}
                    >
                      Habilitar parcelamento no Checkout
                    </Switch>
                    <FormHelperText>Permite que o cliente possa parcelar a cobrança no Checkout.</FormHelperText>
                  </div>
                </BlockedFieldTooltipProps>
              </Tooltip>
            </Grid>
          )}
        {offer.recurring_frequency_type !== recurrencyFrequencyType.Mensal.abbr && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
              <div>
                <Switch
                  color='default'
                  value={offer.send_billing_reminder}
                  onChange={(bool: boolean) => handleChange('send_billing_reminder', bool)}
                  disabled={isAlumy}
                >
                  Enviar notificações de renovação
                </Switch>
                <FormHelperText>Será enviado e-mail para o cliente informando a renovação de sua assinatura.</FormHelperText>
              </div>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        {offer.isVariation() && offer.undetermined_charges && (
          <Grid item xs={12}>
            <Switch onChange={(bool: boolean) => handleChange('allows_upgrade', bool)} value={offer.allows_upgrade} disabled={isAlumy}>
              Habilitar upgrade de plano
            </Switch>
            <FormHelperText>
              Permite que o cliente possa subir de plano de assinatura entre as outras variações desse produto que também tenha essa opção habilitada.
            </FormHelperText>
          </Grid>
        )}
        {offer.isVariation() && offer.undetermined_charges && (
          <Grid item xs={12}>
            <Switch value={offer.allows_downgrade} onChange={(bool: boolean) => handleChange('allows_downgrade', bool)} disabled={isAlumy}>
              Habilitar downgrade de plano
            </Switch>
            <FormHelperText>
              Permite que o cliente possa descer de plano de assinatura entre as outras variações desse produto que também tenha essa opção
              habilitada.
            </FormHelperText>
          </Grid>
        )}
        <Grid item xs={12}>
          <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
            <div>
              <Switch value={offer.remove_access} onChange={(bool: boolean) => handleChange('remove_access', bool)} disabled={isAlumy}>
                Remover acesso ao conteúdo
              </Switch>
              <FormHelperText>O acesso ao conteúdo será removido caso a assinatura fique em atraso.</FormHelperText>
            </div>
          </BlockedFieldTooltipProps>
        </Grid>
        <Grid item xs={12}>
          <BlockedFieldTooltipProps product={offer} enabled={isAlumy}>
            <div>
              <CustomMaskedInput
                label='Limite de atraso'
                id='overdue_limit'
                mask='number'
                error={this.isValid('overdue_limit')}
                fullWidth={true}
                disableUnderline={true}
                defaultValue={5}
                value={offer.overdue_limit}
                onChange={(value: any) => handleChange('overdue_limit', value)}
                disabled={isAlumy}
              />
              <FormHelperText>
                {this.isValid('overdue_limit')
                  ? this.errorFor('overdue_limit')
                  : `Após ${offer.overdue_limit} cobrança(s) consecutivas em atraso, a assinatura será cancelada automaticamente.`}
              </FormHelperText>
            </div>
          </BlockedFieldTooltipProps>
        </Grid>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    loggedUser: new User(state.orbita.User.user),
  };
}

export default connect(mapStateToProps)(styles(Subscription));
